import { callFirebaseHttpFunction } from "../callFirebaseHttpFunction"

export const getUnauthenticatedCruiseDetails = async (
  tripId: string,
  tripSearchId: string,
  docId: string,
) => {
  try {
    const result = await callFirebaseHttpFunction({
      name: "publicGetCruiseDetails",
      payload: { tripId, tripSearchId, tripSearchResultId: docId },
    })

    return result.data?.result
  } catch (error) {
    console.error("getting cruise details error", { error })
    return null
  }
}
